import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import { window } from '../../helpers/BrowserHelpers';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SearchIcon } from '../Icons';
import Downshift from 'downshift';
import './style.css';

var Dropdown =
/*#__PURE__*/
function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, props));
    var preventCloseOnSelect = props.preventCloseOnSelect;
    _this.state = preventCloseOnSelect ? {
      isOpen: false
    } : {
      isOpen: null
    };
    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var preventCloseOnSelect = this.props.preventCloseOnSelect;

      if (!preventCloseOnSelect) {
        return false;
      }

      this._isMounted = true;

      var onMouseDown = function onMouseDown() {
        _this2.isMouseDown = true;
      };

      var onMouseUp = function onMouseUp(event) {
        _this2.isMouseDown = false;

        if ((event.target === _this2.downshift._rootNode || !_this2.downshift._rootNode.contains(event.target)) && _this2.state.isOpen) {
          _this2.setState({
            isOpen: false
          });
        }
      };

      window.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mouseup', onMouseUp);

      this.cleanup = function () {
        _this2._isMounted = false;
        window.removeEventListener('mousedown', onMouseDown);
        window.removeEventListener('mouseup', onMouseUp);
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cleanup && this.cleanup();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          onSelect = _this$props.onSelect,
          preventCloseOnSelect = _this$props.preventCloseOnSelect,
          defaultIsOpen = _this$props.defaultIsOpen,
          restProps = _objectWithoutProperties(_this$props, ["children", "onSelect", "preventCloseOnSelect", "defaultIsOpen"]);

      var isOpen = this.state.isOpen;
      var controlledProps = preventCloseOnSelect ? {
        isOpen: isOpen
      } : {};
      return React.createElement(Downshift, Object.assign({
        defaultIsOpen: defaultIsOpen,
        ref: function ref(downshift) {
          _this3.downshift = downshift;
        },
        onChange: function onChange(item, props) {
          if (item) {
            onSelect(item);
          }

          props.toggleMenu();
          props.clearSelection();
        }
      }, controlledProps, restProps), function (_ref) {
        var _getButtonProps = _ref.getButtonProps,
            restProps = _objectWithoutProperties(_ref, ["getButtonProps"]);

        return children(_objectSpread({
          getButtonProps: function getButtonProps(args) {
            return _objectSpread({}, _getButtonProps(args), {
              onClick: function onClick(event) {
                preventCloseOnSelect ? _this3.setState({
                  isOpen: !_this3.state.isOpen
                }) : _this3.downshift.toggleMenu();
              }
            });
          }
        }, restProps));
      });
    }
  }]);

  return Dropdown;
}(Component);

_defineProperty(Dropdown, "propTypes", {
  preventCloseOnSelect: PropTypes.bool,
  defaultIsOpen: PropTypes.bool,
  onSelect: PropTypes.func,
  children: PropTypes.any
});

_defineProperty(Dropdown, "defaultProps", {
  preventCloseOnSelect: false,
  defaultIsOpen: false
});

var Wrapper = function Wrapper(_ref2) {
  var children = _ref2.children,
      innerRef = _ref2.innerRef,
      className = _ref2.className,
      restProps = _objectWithoutProperties(_ref2, ["children", "innerRef", "className"]);

  return React.createElement("div", Object.assign({
    ref: innerRef,
    className: classNames('position-relative inline-block', className)
  }, restProps), children);
};

var Body = function Body(_ref3) {
  var children = _ref3.children,
      innerRef = _ref3.innerRef,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? {} : _ref3$style,
      placement = _ref3.placement,
      _ref3$placementCustom = _ref3.placementCustomStyle,
      placementCustomStyle = _ref3$placementCustom === void 0 ? {} : _ref3$placementCustom,
      restProps = _objectWithoutProperties(_ref3, ["children", "innerRef", "style", "placement", "placementCustomStyle"]);

  var placementStyle = {};

  if (placement) {
    placementStyle = {
      position: 'absolute'
    };

    switch (placement) {
      case 'left':
        placementStyle = _objectSpread({}, placementStyle, {
          top: 0,
          right: '100%',
          left: 'auto',
          bottom: 'auto'
        });
        break;

      case 'right':
        placementStyle = _objectSpread({}, placementStyle, {
          top: 0,
          left: '100%',
          right: 'auto',
          bottom: 'auto'
        });
        break;

      case 'top':
        placementStyle = _objectSpread({}, placementStyle, {
          top: 'auto',
          left: '0',
          right: '100%',
          bottom: 'auto'
        });
        break;

      case 'bottom':
        placementStyle = _objectSpread({}, placementStyle, {
          top: '100%',
          left: '0',
          right: 'auto',
          bottom: 'auto'
        });
        break;

      case 'bottom-left':
        placementStyle = _objectSpread({}, placementStyle, {
          top: '100%',
          left: 'auto',
          right: '0',
          bottom: 'auto'
        });
        break;

      case 'custom':
        placementStyle = _objectSpread({}, placementStyle, {}, placementCustomStyle);
        break;

      default:
        break;
    }
  }

  return React.createElement("div", Object.assign({
    ref: innerRef,
    className: "dropdown-body color-mode-elevated shadow-hovering radius-normal overflow-hidden zindex-small text-align-left",
    style: _objectSpread({
      width: 300
    }, placementStyle, {}, style)
  }, restProps), children);
};

var Menu = function Menu(_ref4) {
  var _ref4$scrolling = _ref4.scrolling,
      scrolling = _ref4$scrolling === void 0 ? false : _ref4$scrolling,
      className = _ref4.className,
      children = _ref4.children;
  return React.createElement("div", {
    className: classNames({
      'scroll-y': scrolling
    }, className),
    style: {
      maxHeight: scrolling ? 260 : null
    }
  }, children);
};

var Title = function Title(_ref5) {
  var children = _ref5.children,
      className = _ref5.className;
  return React.createElement("div", {
    className: classNames('background-white padding-vertical-normal padding-horizontal-medium bold border-bottom-medium border-shade-50', className)
  }, children);
};

var Header = function Header(_ref6) {
  var children = _ref6.children,
      className = _ref6.className;
  return React.createElement("div", {
    className: classNames('background-white padding-medium', className)
  }, children);
};

var Divider = function Divider(_ref7) {
  var children = _ref7.children;
  return children ? React.createElement("div", {
    className: "background-shade-50 full-width padding-horizontal-large padding-vertical-small font-size-smaller uppercase shade-30 bold",
    style: {
      letterSpacing: '1px'
    }
  }, children) : React.createElement("div", {
    className: "background-shade-50 full-width",
    style: {
      height: 2
    }
  });
};

var Item = function Item(_ref8) {
  var icon = _ref8.icon,
      children = _ref8.children,
      _ref8$divider = _ref8.divider,
      divider = _ref8$divider === void 0 ? false : _ref8$divider,
      subtitle = _ref8.subtitle,
      selected = _ref8.selected,
      style = _ref8.style,
      className = _ref8.className,
      restProps = _objectWithoutProperties(_ref8, ["icon", "children", "divider", "subtitle", "selected", "style", "className"]);

  return React.createElement("div", Object.assign({
    className: classNames('padding-vertical-normal padding-horizontal-medium pointer', 'background-shade-50-on-hover background-shade-50-on-focus', 'font-weight-medium shade-05-on-hover shade-05-on-focus', {
      'border-bottom-medium border-shade-50': divider,
      'background-shade-50 shade-05': selected,
      'background-white shade-10 ': !selected
    }, className),
    style: _objectSpread({
      lineHeight: '26px'
    }, style)
  }, restProps), React.createElement("div", {
    className: "flexbox flexbox-align-center"
  }, icon && React.createElement("div", {
    className: "flexbox-no-grow padding-right-normal shade-30",
    style: {
      marginTop: '-2px'
    }
  }, icon), React.createElement("div", {
    className: "flexbox-grow"
  }, subtitle ? React.createElement("div", {
    style: {
      lineHeight: '14px'
    }
  }, React.createElement("div", {
    className: "font-weight-medium"
  }, children), React.createElement("div", {
    className: "font-weight-regular font-size-smaller"
  }, subtitle)) : React.createElement("div", null, children))));
};

var Button = function Button(_ref9) {
  var children = _ref9.children,
      selected = _ref9.selected,
      to = _ref9.to,
      restProps = _objectWithoutProperties(_ref9, ["children", "selected", "to"]);

  return React.createElement('div', _objectSpread({
    className: classNames('padding-vertical-normal padding-horizontal-medium pointer', 'background-white background-shade-50-on-hover background-shade-50-on-focus', 'font-weight-medium shade-10 shade-05-on-hover shade-05-on-focus center-text', {
      'background-shade-50 shade-05': selected
    }),
    to: to,
    style: {
      display: 'block',
      lineHeight: '26px'
    }
  }, restProps), children);
};

var SearchInput = function SearchInput(_ref10) {
  var value = _ref10.value,
      _ref10$withIcon = _ref10.withIcon,
      withIcon = _ref10$withIcon === void 0 ? true : _ref10$withIcon,
      restProps = _objectWithoutProperties(_ref10, ["value", "withIcon"]);

  return React.createElement("div", {
    className: "background-white padding-vertical-normal padding-horizontal-medium flexbox border-bottom-medium border-shade-50"
  }, withIcon && React.createElement("div", {
    className: "flexbox-no-grow padding-right-normal shade-30"
  }, React.createElement(SearchIcon, null)), React.createElement("div", {
    className: "flexbox-grow"
  }, React.createElement("input", Object.assign({
    className: "slite-editor-dropdown-search-input shade-05 font-size-normal font-weight-medium width-full border-none background-transparent",
    type: "text",
    autoFocus: true,
    value: value || ''
  }, restProps))));
};

Dropdown.Body = Body;
Dropdown.Wrapper = Wrapper;
Dropdown.Menu = Menu;
Dropdown.Title = Title;
Dropdown.Header = Header;
Dropdown.Divider = Divider;
Dropdown.Item = Item;
Dropdown.Button = Button;
Dropdown.SearchInput = SearchInput;
export default Dropdown;